// extracted by mini-css-extract-plugin
module.exports = {"main-container":"AgentiList_main-container__2oCSU","italy-map":"AgentiList_italy-map__2QoXk"};